import React from "react";
import PropTypes from "prop-types";
import dayjs from "dayjs";

const TablewithSumFooter = ({
  columns,
  columnNames,
  data,
  showProceedButton = false,
  buttonName = "Proceed",
  rowNameKey = "rowname",
  valueKey = 1,
  onRowClick = () => {},
  onButtonClick = () => {},
}) => {
  let qty = 0;
  let val = 0;

  const showQty = columns.some((col) =>
    col.toLowerCase().includes("itemquantity")
  );

  const showVal = columns.some((col) =>
    col.toLowerCase().includes("itemvalue")
  );

  /* =========================================================
     CALCULATE TOTALS
     ========================================================= */
  if (showQty || showVal) {
    data.forEach((row) => {
      columns.forEach((column) => {
        const value = parseFloat(row[column]);

        if (!isNaN(value)) {
          if (
            showQty &&
            column.toLowerCase().includes("itemquantity")
          ) {
            qty += value;
          }

          if (
            showVal &&
            column.toLowerCase().includes("itemvalue")
          ) {
            val += value;
          }
        }
      });
    });
  }

  /* =========================================================
     DATE FORMAT
     ========================================================= */
  const formatCellValue = (column, value) => {
    if (
      value === null ||
      value === undefined ||
      value === ""
    ) {
      return "";
    }

    if (column.toLowerCase().includes("date")) {
      const parsedDate = dayjs(value);

      if (parsedDate.isValid()) {
        return parsedDate.format("DD-MMM-YYYY");
      }
    }

    return value;
  };

  return (
    <>
      <style>{`
        /* =====================================================
           TABLE WITH SUM FOOTER
           DASHBOARD BLUE THEME
           ===================================================== */

        .sum-table-wrapper {
          width: 100%;
          max-width: 100%;
          min-width: 0;
          box-sizing: border-box;

          margin: 16px 0;
          padding: 0;

          background: #ffffff;

          border: 1px solid #dbe5f1;
          border-radius: 12px;

          box-shadow: 0 4px 14px rgba(13, 71, 161, 0.09);

          overflow: hidden;
        }

        .sum-table-container {
          width: 100%;
          max-width: 100%;
          min-width: 0;
          box-sizing: border-box;

          overflow: hidden;
        }

        .sum-table {
          width: 100% !important;
          max-width: 100% !important;
          min-width: 0 !important;

          margin: 0 !important;

          border-collapse: collapse;
          border-spacing: 0;

          table-layout: fixed !important;

          font-size: 14px;
        }

        /* =====================================================
           HEADER
           ===================================================== */

        .sum-table thead th {
          background: linear-gradient(
            135deg,
            #0d47a1 0%,
            #1565c0 50%,
            #1976d2 100%
          ) !important;

          color: #ffffff !important;

          font-weight: 700;
          font-size: 13px;

          text-align: center;
          vertical-align: middle;

          padding: 10px 7px;

          border: 1px solid rgba(255, 255, 255, 0.22);

          white-space: normal !important;
          overflow-wrap: anywhere !important;
          word-break: break-word !important;
        }

        /* =====================================================
           BODY
           ===================================================== */

        .sum-table tbody tr {
          transition: background 0.15s ease;
        }

        .sum-table tbody tr:nth-child(even) {
          background: #f7faff;
        }

        .sum-table tbody tr:hover {
          background: #eaf3ff;
        }

        .sum-table tbody td {
          color: #263238;

          padding: 9px 7px;

          border: 1px solid #dce6f0;

          text-align: left;
          vertical-align: middle;

          white-space: normal !important;
          overflow-wrap: anywhere !important;
          word-break: break-word !important;

          line-height: 1.4;

          overflow: hidden;
        }

        /* =====================================================
           ACTION COLUMN
           ===================================================== */

        .sum-table .action-header {
          width: 82px;
          text-align: center;
        }

        .sum-table .action-cell {
          width: 82px;
          text-align: center !important;
          vertical-align: middle;
        }

        .sum-table-action-btn {
          width: 100%;
          max-width: 76px;

          border: none;
          border-radius: 6px;

          padding: 7px 6px;

          color: #ffffff;

          font-size: 12px;
          font-weight: 700;

          cursor: pointer;

          background: linear-gradient(
            135deg,
            #1565c0,
            #1976d2
          );

          box-shadow: 0 2px 5px rgba(13, 71, 161, 0.20);

          transition: all 0.18s ease;

          white-space: normal;
          overflow-wrap: anywhere;
          word-break: break-word;
        }

        .sum-table-action-btn:hover {
          transform: translateY(-1px);

          box-shadow:
            0 4px 8px rgba(13, 71, 161, 0.25);
        }

        .sum-table-action-btn:disabled {
          background: #b0bec5;

          color: #ffffff;

          cursor: not-allowed;

          opacity: 0.75;

          box-shadow: none;

          transform: none;
        }

        .sum-table-action-btn-danger {
          background: linear-gradient(
            135deg,
            #c62828,
            #e53935
          );
        }

        /* =====================================================
           FOOTER / TOTAL
           ===================================================== */

        .sum-table tfoot td {
          background: linear-gradient(
            135deg,
            #eaf3ff,
            #f5f9ff
          ) !important;

          color: #0d47a1 !important;

          border: 1px solid #cbdcf0;

          padding: 11px 10px;

          text-align: center !important;

          font-size: 14px;
          font-weight: 700;

          white-space: normal !important;
          overflow-wrap: anywhere !important;
          word-break: break-word !important;
        }

        .sum-footer-label {
          display: inline-block;

          padding: 4px 12px;

          border-radius: 20px;

          background: #ffffff;

          border: 1px solid #c8dcf3;

          color: #0d47a1;

          font-weight: 700;
        }

        /* =====================================================
           EMPTY DATA
           ===================================================== */

        .sum-table-empty {
          text-align: center !important;

          color: #78909c !important;

          padding: 18px !important;

          font-style: italic;
        }

        /* =====================================================
           TABLET
           ===================================================== */

        @media (max-width: 900px) {
          .sum-table {
            font-size: 13px;
          }

          .sum-table thead th {
            padding: 8px 5px;
            font-size: 12px;
          }

          .sum-table tbody td {
            padding: 8px 5px;
          }

          .sum-table .action-header,
          .sum-table .action-cell {
            width: 75px;
          }

          .sum-table-action-btn {
            max-width: 70px;
            padding: 6px 5px;
            font-size: 11px;
          }
        }

        /* =====================================================
           MOBILE
           ===================================================== */

        @media (max-width: 600px) {
          .sum-table-wrapper {
            margin: 10px 0;
            border-radius: 9px;
          }

          .sum-table {
            font-size: 12px !important;
          }

          .sum-table thead th {
            padding: 7px 4px !important;

            font-size: 11px !important;

            line-height: 1.25;
          }

          .sum-table tbody td {
            padding: 7px 4px !important;

            font-size: 11px !important;

            line-height: 1.3;
          }

          .sum-table .action-header,
          .sum-table .action-cell {
            width: 65px;
          }

          .sum-table-action-btn {
            max-width: 62px;

            padding: 6px 3px;

            font-size: 10px;

            line-height: 1.2;
          }

          .sum-table tfoot td {
            padding: 9px 5px !important;

            font-size: 12px !important;
          }

          .sum-footer-label {
            padding: 4px 8px;
          }
        }

        /* =====================================================
           VERY SMALL MOBILE
           ===================================================== */

        @media (max-width: 380px) {
          .sum-table {
            font-size: 11px !important;
          }

          .sum-table thead th {
            font-size: 10px !important;
            padding: 6px 3px !important;
          }

          .sum-table tbody td {
            font-size: 10px !important;
            padding: 6px 3px !important;
          }

          .sum-table .action-header,
          .sum-table .action-cell {
            width: 58px;
          }

          .sum-table-action-btn {
            max-width: 55px;
            font-size: 9px;
            padding: 5px 2px;
          }
        }
      `}</style>

      <div className="sum-table-wrapper">
        <div className="sum-table-container">
          <table
            className="sum-table"
            role="table"
          >
            {/* =================================================
                HEADER
                ================================================= */}
            <thead>
              <tr>
                {columnNames.map((name, index) => (
                  <th
                    key={index}
                    scope="col"
                  >
                    {name}
                  </th>
                ))}

                {showProceedButton && (
                  <th
                    scope="col"
                    className="action-header"
                  >
                    Action
                  </th>
                )}
              </tr>
            </thead>

            {/* =================================================
                BODY
                ================================================= */}
            <tbody>
              {data.length > 0 ? (
                data.map((row, rowIndex) => (
                  <tr
                    key={rowIndex}
                    onClick={() =>
                      onRowClick(row[rowNameKey])
                    }
                    style={{
                      cursor:
                        onRowClick !== (() => {})
                          ? "pointer"
                          : "default",
                    }}
                  >
                    {columns.map(
                      (column, colIndex) => {
                        const isPendingDays =
                          column
                            .toLowerCase()
                            .includes(
                              "pending days"
                            );

                        return (
                          <td
                            key={colIndex}
                            style={{
                              textAlign:
                                isPendingDays
                                  ? "center"
                                  : undefined,
                            }}
                          >
                            {formatCellValue(
                              column,
                              row[column]
                            )}
                          </td>
                        );
                      }
                    )}

                    {/* =======================================
                        ACTION
                        ======================================= */}
                    {showProceedButton && (
                      <td className="action-cell">
                        <button
                          type="button"
                          className={`sum-table-action-btn ${
                            row[rowNameKey] ===
                            valueKey
                              ? "sum-table-action-btn-danger"
                              : ""
                          }`}
                          disabled={
                            row[rowNameKey] ===
                            valueKey
                          }
                          onClick={(e) => {
                            e.stopPropagation();
                            onButtonClick(row);
                          }}
                        >
                          {buttonName}
                        </button>
                      </td>
                    )}
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan={
                      columns.length +
                      (showProceedButton
                        ? 1
                        : 0)
                    }
                    className="sum-table-empty"
                  >
                    No records available
                  </td>
                </tr>
              )}
            </tbody>

            {/* =================================================
                TOTAL FOOTER
                ================================================= */}
            <tfoot>
              {(showQty || showVal) && (
                <tr>
                  <td
                    colSpan={
                      columns.length +
                      (showProceedButton
                        ? 1
                        : 0)
                    }
                  >
                    <span className="sum-footer-label">
                      {showQty && showVal
                        ? `Qty: ${qty.toFixed(
                            2
                          )}  |  Val: ${val.toFixed(
                            2
                          )}`
                        : showQty
                        ? `Qty: ${qty.toFixed(
                            2
                          )}`
                        : `Val: ${val.toFixed(
                            2
                          )}`}
                    </span>
                  </td>
                </tr>
              )}
            </tfoot>
          </table>
        </div>
      </div>
    </>
  );
};

TablewithSumFooter.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.string
  ).isRequired,

  columnNames: PropTypes.arrayOf(
    PropTypes.string
  ).isRequired,

  data: PropTypes.arrayOf(
    PropTypes.object
  ).isRequired,

  showProceedButton: PropTypes.bool,

  buttonName: PropTypes.string,

  rowNameKey: PropTypes.string,

  valueKey: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),

  onRowClick: PropTypes.func,

  onButtonClick: PropTypes.func,
};

export default TablewithSumFooter;